class CustomParallax extends HTMLElement {
  constructor() {
    super();
    this.imageContainers = this.querySelectorAll(".parallax-image-container");
    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.intersectionOptions = {
      root: null,
      rootMargin: "0% 0% 0% 0%",
      threshold: 0.375, //  3/4 of screen height
    };

    this.observer = new IntersectionObserver(
      this.handleIntersection,
      this.intersectionOptions
    );

    this.observer.observe(this);
  }

  handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.fadeInImages();
        window.addEventListener("scroll", this.handleScroll);
      } else {
        this.fadeOutImages();
        window.removeEventListener("scroll", this.handleScroll);
      }
    });
  }

  fadeInImages() {
    this.imageContainers.forEach((container) => {
      container.setAttribute("in-view", "");
    });
  }

  fadeOutImages() {
    this.imageContainers.forEach((container) => {
      container.removeAttribute("in-view");
    });
  }

  handleScroll() {
    const scrollY = window.scrollY;

    this.imageContainers.forEach((container) => {
      const speed = container.dataset.speed || 1;
      const scale4k = container.dataset["scale-4k"];
      const scale5k = container.dataset["scale-5k"];
      const val =
        scrollY + window.innerHeight / 4 - this.closest("div").offsetTop;

      if (window.innerWidth >= 2560 && window.innerWidth <= 3840) {
        container.style.transform = `scale(${scale4k}) translate3d(0px, ${
          val * speed
        }px, 0px)`;
      } else if (window.innerWidth > 3840) {
        container.style.transform = `scale(${scale5k}) translate3d(0px, ${
          val * speed
        }px, 0px)`;
      } else {
        container.style.transform = `translate3d(0px, ${val * speed}px, 0px)`;
      }
    });
  }
}

customElements.define("custom-parallax", CustomParallax);
